.add-email-container {
    width: 500px;
}
